import React, {Component} from 'react'
import TextField from 'material-ui/TextField'
import {Card, CardActions, CardHeader, CardText} from 'material-ui/Card'
import {Tabs, Tab} from 'material-ui/Tabs'
import Paper from 'material-ui/Paper'
import RaisedButton from 'material-ui/RaisedButton'
import {cardStyles, styles, weeklyDayPickerClassNames} from '../Constants'
import Agenda from './Agenda'
import DaySchedule from './DaySchedule'

import ReactWeeklyDayPicker from 'react-weekly-day-picker'
import 'react-day-picker/lib/style.css'
import * as firebase from 'firebase'

export default class AppointmentsManager extends Component {
  constructor(props) {
    super(props)
    let theDay = []
    theDay.push(new Date().toISOString().split("T")[0])
    this.state = {
      theDay: theDay,
      isOnAgenda: true,
      isOnSchedule: false,
    }
  }

  setOnAgenda = () => {
    this.setState({
      isOnAgenda: true,
      isOnSchedule: false,
    })
  }

  setOnSchedule = () => {
    this.setState({
      isOnAgenda: false,
      isOnSchedule: true,
    })
  }

  handleDayClick(date) {
    let self = this
    let aDay = date
    self.setState({
      isOnAgenda: false,
      isOnSchedule: true,
      theDay: aDay,
    })
  }

  render() {
    let self = this
    var cats = ["Barber Shops", "Hair Salons", "Massage", "Nail Salons",
                "Spa", "Makeup", "Shoe Shine"]
    var catsChosen = []
    var i = -1
    for (var property in self.props.categoriesSelected) {
      i++
      if (self.props.categoriesSelected.hasOwnProperty(property)) {
        if(self.props.categoriesSelected[property]) {
          catsChosen.push(i)
        }
      }
    }
    if(self.state.isOnAgenda) {
      return (
        <Paper style={cardStyles}>
          <CardHeader
            actAsExpander={true}
            showExpandableButton={true}
            title={self.props.displayName}
            subtitle={self.props.email}
            avatar={"logo.png"}/>
            <RaisedButton
              className="center"
              label="Sign Out"
              backgroundColor={"#F5F5F5"}
              onClick={self.signInOut} /> &nbsp;&nbsp;&nbsp;
            <RaisedButton
              className="center"
              label="Agenda"
              backgroundColor={self.state.isOnAgenda ? "#251B32" : "#F5F5F5"}
              labelColor={self.state.isOnAgenda ? "#DCA3AC" : "#251B32"}
              onClick={self.setOnAgenda} /> &nbsp;&nbsp;&nbsp;
            <RaisedButton
              className="center"
              label="Schedule"
              backgroundColor={self.state.isOnSchedule ? "#251B32" : "#F5F5F5"}
              labelColor={self.state.isOnSchedule ? "#DCA3AC" : "#251B32"}
              onClick={self.setOnSchedule} />
            <Agenda
              user={self.state.uid}
              photoURL={self.state.photoURL}
              displayName={self.state.displayName}
              email={self.state.userEmail}
              onCategorySelected={self.onCategorySelected}/>
        </Paper>
      )
    }
    return (
      <Paper style={cardStyles}>
        <CardHeader
          actAsExpander={true}
          showExpandableButton={true}
          title={self.props.displayName}
          subtitle={self.props.email}
          avatar={"logo.png"}/>
          <RaisedButton
            className="center"
            label="Sign Out"
            backgroundColor={"#F5F5F5"}
            onClick={self.signInOut} /> &nbsp;&nbsp;&nbsp;
          <RaisedButton
            className="center"
            label="Agenda"
            backgroundColor={self.state.isOnAgenda ? "#251B32" : "#F5F5F5"}
            labelColor={self.state.isOnAgenda ? "#DCA3AC" : "#251B32"}
            onClick={self.setOnAgenda} /> &nbsp;&nbsp;&nbsp;
          <RaisedButton
            className="center"
            label="Schedule"
            backgroundColor={self.state.isOnSchedule ? "#251B32" : "#F5F5F5"}
            labelColor={self.state.isOnSchedule ? "#DCA3AC" : "#251B32"}
            onClick={self.setOnSchedule} />
          <div className="center">
            <ReactWeeklyDayPicker
              daysCount={7}  //How many days will be shown
              classNames={weeklyDayPickerClassNames}
              startDay={new Date()} // First day as Date Object or 22 June 2016
              selectedDays={self.state.theDay} // Selected days list
              multipleDaySelect={false} //enables multiple day selection
              selectDay={self.handleDayClick.bind(this)}
              unselectDay={function(day){}}
              onPrevClick={function(startDay, selectedDays){}} // called with the new startDay
              onNextClick={function(startDay, selectedDays){}} // called with the new startDay
              unselectable={false} // if true allows to unselect a date once it has been selected. Only works when multipleDaySelect={false}
              format={'YYYY-MM-DD'} //format of dates that handled in selectDay and unselectDay functions
              firstLineFormat={'ddd'} // format for the first line of the day button
              secondLineFormat={'MMM D'} // format for the second line of the day button
              firstLineMobileFormat={'dddd'} // format for the first line of the day button mobile
              secondLineMobileFormat={'MMMM D, Y'} // format for the second line of the day button mobile
              unavailables={{
                weekly: [0, 6] //unavailable dates list for each week (0:Sunday, 1:Monday ...)
              }}
              mobilView={window.innerWidth < 1024}  // enables mobil view
              beforeToday={true}   // all dates before today set as unavailable (default:true)
              todayText={" "}  // replacing today text (default : - TODAY -)
              unavailableText={" "}  // replacing unavailable text (default: unavailable )
              />
          </div>
          <DaySchedule theDay={self.state.theDay}/>
      </Paper>
    )
  }

}



// WEBPACK FOOTER //
// ./src/react/AppointmentsManager.js